import React from 'react';
import { HierarchyPageSortable } from 'modules/settings/submodules/components/HierarchyPage/HierarchyPageSortable';

export const ClientCustomFieldHierarchyRoot = () => {
    return (
        <HierarchyPageSortable />
    );
};
